import { useMainStore } from '@/stores/main';
import { usePage } from '@inertiajs/vue3';

export default function useInitStoreData() {
  const store = useMainStore();

  /**
   * Execute initialize of Store data.
   */
  function execute() {
    store.setBaseData({
      user: usePage().props.user,
      broker: usePage().props.broker,
    });
  }

  return {
    execute,
  };
}
